import { pickTargetingValues } from './pick-targeting-values';
const surges = {
    0: '0',
    50: '5',
    100: '4',
    200: '3',
    300: '2',
    400: '1',
};
/* -- Methods -- */
const getSurgingParam = (surging) => {
    if (surging < 50 || isNaN(surging))
        return ['0'];
    const thresholds = [400, 300, 200, 100, 50];
    return thresholds.filter((n) => n <= surging).map((s) => surges[s]);
};
/* -- Targeting -- */
/**
 * What goes in comes out
 */
const getSharedTargeting = (shared) => pickTargetingValues(shared);
export const _ = {
    getSurgingParam,
};
export { getSharedTargeting };
